import React from "react";

import useCandidateIntro from "./useCandidateIntro";
import "./CandidateIntro.scss";
import {Spinner } from "react-bootstrap";

export default (props) => {
  const { loading, userData, educationData, professionData } =
    useCandidateIntro(props);

  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <div className="candidate-intro-container mt-4 bg-grey-3 panel-right rounded px-4">
          <div className="p-2 d-flex align-items-start text-capitalize">
            <span className="user-img mr-3">
              <img src="./assets/images/user.png" alt="user image" />
            </span>
            <div className="py-3">
              <h2 className="text-primary">{userData.user_full_name}</h2>{" "}
              <span className="font-weight-semi">{userData.headline}</span>
            </div>
          </div>
          <div className="candidate-intro-wrapper rounded-lg border">
            <div className="top bg-grey-2 py-3 px-4 ">
              <h3 className="font-weight-medium">Candidate Information</h3>
            </div>
            <div className="bg-white">
              {userData && (
                <div className="p-4">
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <h3 className="mb-2">Headline/Title</h3>
                      <p className="text-grey-4 text-capitalize">
                        {userData.headline
                          ? userData.headline
                          : "Not Available"}
                      </p>
                    </div>
                    <div className="col-md-6 col-lg-4 mb-3">
                      <h3 className="mb-2">Name</h3>
                      <p className="text-grey-4 text-capitalize">
                        {userData.user_full_name
                          ? userData.user_full_name
                          : "Not Available"}
                      </p>
                    </div>

                    <div className="col-md-6 col-lg-4 mb-3">
                      <h3 className="mb-2">Email</h3>

                      <p className="text-grey-4">
                        {userData.user_email
                          ? userData.user_email
                          : "Not Available"}
                      </p>
                    </div>
                    <div className="col-md-6 col-lg-4 mb-3">
                      <h3 className="mb-2">Phone</h3>

                      <p className="text-grey-4">
                        {userData.user_meta_info?.phone
                          ? userData.user_meta_info?.phone
                          : "Not Available"}
                      </p>
                    </div>
                    <div className="col-md-6 col-lg-4 mb-3">
                      <h3 className="mb-2">Date of Birth</h3>

                      <p className="text-grey-4">
                        {userData.dob
                          ? userData.dob?.split("-")?.reverse()?.join("-")
                          : "Not Available"}
                      </p>
                    </div>
                    <div className="col-md-6 col-lg-4 mb-3">
                      <h3 className="mb-2">Gender</h3>
                      <p className="text-grey-4 text-capitalize">
                        {userData.gender ? userData.gender : "Not Available"}
                      </p>
                    </div>

                    {userData.candidate_website &&
                      <div className="col-md-6 col-lg-4 mb-3">
                        <h3 className="mb-2">Website</h3>
                        <p className="font-weight-medium">
                          <a href={userData?.candidate_website} target="_blank">
                            {userData.candidate_website && userData.candidate_website.substring(
                              0,
                              30
                            ) + "..."
                            }
                          </a>
                        </p>
                      </div>
                    }
                    {userData.linkedin_url &&
                      <div className="col-md-6 col-lg-4 mb-3">
                        <h3 className="mb-2">LinkedIn Link</h3>
                        <p className="font-weight-medium">
                          <a href={userData?.linkedin_url} target="_blank">
                            {userData.linkedin_url.substring(
                              0,
                              30
                            ) + "..."
                            }
                          </a>
                        </p>
                      </div>
                    }

                    {userData.github_url &&
                      <div className="col-md-6 col-lg-4 mb-3">
                        <h3 className="mb-2">Github Link</h3>
                        <p className="font-weight-medium">
                          <a href={userData?.github_url} target="_blank">
                            {userData.github_url && userData.github_url.substring(
                              0,
                              30
                            ) + "..."
                            }
                          </a>
                        </p>
                      </div>
                    }
                    <div className="col-md-6 col-lg-4 mb-3">
                      <h3 className="mb-2">City</h3>

                      <p className="text-grey-4 text-capitalize">
                        {userData.city_name
                          ? userData.city_name
                          : "Not Available"}
                      </p>
                    </div>

                    <div className="col-md-6 col-lg-4 mb-3">
                      <h3 className="mb-2">State</h3>
                      <p className="text-grey-4 text-capitalize">
                        {userData.state_name
                          ? userData.state_name
                          : "Not Available"}
                      </p>
                    </div>
                    <div className="col-md-6 col-lg-4 mb-3">
                      <h3 className="mb-2">Country</h3>

                      <p className="text-grey-4">
                        {userData.country_name ? (
                          <span className="text-uppercase">
                            {userData.country_name}
                          </span>
                        ) : (
                          "Not Available"
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="education-wrapper rounded-lg my-4 border">
            <div className="top bg-grey-2 py-3 px-4 ">
              <h3 className="font-weight-medium">Educational Information</h3>
            </div>
            <div className="bg-white">
              <ul className="p-4">
                {Array.isArray(educationData) &&
                  educationData.map((data) => (
                    <li className="mb-4" key={data?.id}>
                      <p className="mb-1 font-weight-bold">
                        {data?.school_name && data.school_name.toUpperCase()}
                      </p>

                      <div className="text-capitalize">
                        <p className="mb-1 text-grey-4">
                          {data?.college_degree_name}
                        </p>
                      </div>

                      <div className="text-uppercase">
                        <p className="text-grey-4">
                          {data?.field_of_study_name}
                        </p>
                      </div>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
          <div className="profession-wrapper rounded-lg my-4 border">
            <div className="top bg-grey-2 py-3 px-4 ">
              <h3 className="font-weight-medium">Professional Information</h3>
            </div>
            <div className="bg-white">
              <ul className="p-4">
                {Array.isArray(professionData) &&
                  professionData.map((data) => (
                    <li className="mb-3" key={data?.id}>
                      <div>
                        <p className="font-weight-bold mb-1 text-uppercase">
                          {data?.company_name}
                        </p>
                      </div>
                      <div>
                        <p className="text-grey-4 text-capitalize mb-1">
                          {data?.job_title}
                        </p>
                      </div>

                      <div className="d-inline-block">
                        <p className="text-grey-4 text-capitalize mb-1">
                          {data?.city_name},{" "}
                        </p>
                      </div>

                      <div className="d-inline-block">
                        <p className="text-grey-4 text-capitalize mb-1">
                          {data?.state_name},{" "}
                        </p>
                      </div>
                      <div className="d-inline-block">
                        <p className="text-grey-4 text-capitalize mb-1">
                          {data?.country_name}
                        </p>
                      </div>
                    </li>
                  ))}
              </ul>
            </div>
          </div>

          <div className="col-12 pb-4 px-0">
            <div className="my-4 border">
              <div className="top bg-grey-2 py-3 px-4">
                <h3 className="font-weight-medium">Skills</h3>
              </div>
              {/* candidate skills to be shown here */}
              <div className="card-body bg-white">
                <ul className="d-flex align-items-center flex-wrap">
                  {userData?.skills &&
                    Array.isArray(userData?.skills) &&
                    userData.skills.map((item) => (
                      <li
                        className="bg-grey-3 rounded h4 font-weight-normal px-2 py-1 ml-2 text-capitalize"
                        key={item?.id}
                      >
                        {item.skill_name}
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
